import { createSlice } from '@reduxjs/toolkit'

// Define the type for the state
interface StateType {
    formList: any[] // Replace 'any' with a more specific type if possible
}

interface Form {
    formId: string
    id: string
}
// Define the type for the action
// interface ActionType {
//     payload: {
//         data: any;  // Replace 'any' with the specific type of the data
//     }
// }

const formState: StateType = {
    formList: [],
}

const formSlice = createSlice({
    name: 'forms',
    initialState: formState,
    reducers: {
        saveFormList: (state, action) => {
            state.formList = action.payload.data
        },
        deleteForm: (state, action) => {
            state.formList = state.formList.filter(
                (form: Form) => form.formId !== action.payload.id
            )
        },
        updateFormStatus: (state, action) => {
            const data = action.payload
            // Find the index of the form with the matching id
            const index = state.formList.findIndex(
                (form: Form) => form.id === data.id
            )
            if (index !== -1) {
                // Use map to create a new array with the updated form
                state.formList = state.formList.map((form, idx) => {
                    if (idx === index) {
                        // If the index matches, update the desired keys
                        return {
                            ...form,
                            status: 'Completed',
                        }
                    }
                    // Otherwise, return the original form
                    return form
                })
            }
        },
    },
})

export default formSlice.reducer

export const { saveFormList, deleteForm, updateFormStatus } = formSlice.actions
